export default class ClassicQuizParticipationQuestionModel {
  public questionId: number = null;
  public optionId: number = null;
  public correct: boolean = null;
}
